import axios from "axios";
import { baseUrlApiOtodis, baseUrlOtodis, xApiKeyOtodis } from "../../config/api/apiConfig";

class SettingOtodisApiService {
  private axios = axios.create({
    baseURL: baseUrlOtodis,
  });

  private newAxios = axios.create({
    baseURL: baseUrlApiOtodis,
  });

  public setToken(token: string) {
    this.axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    this.newAxios.defaults.headers.common["Authorization"] = "Bearer " + token;
  }

  public async getWarehouse(params?: { dealerCode?: string; active?: boolean }) {
    const queries = {
      lite_respon: false,
      ...(params?.dealerCode && {
        dealer_code: params.dealerCode,
      }),
      ...(params?.active && {
        active: params.active,
      }),
    };
    try {
      return await this.newAxios.get<any>("/warehouse", {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
        params: {
          ...queries,
        },
      });
    } catch (e: any) {
      throw new Error(e);
    }
  }

  public async getStockTransferWarehouse(params?: { dealerCode?: string; startDate?: string; endDate?: string; dataType?: string; transferCode?: string }) {
    const queries = {
      ...(params?.dealerCode && {
        dealer_code: params.dealerCode,
      }),
      ...(params?.startDate && {
        start_date: params.startDate,
      }),
      ...(params?.endDate && {
        end_date: params.endDate,
      }),
      ...(params?.dataType && {
        data_type: params.dataType,
      }),
      ...(params?.transferCode && {
        transfer_code: params.transferCode,
      }),
    };
    try {
      return await this.axios.get<any>("stock/transfer-warehouse", {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
        params: {
          ...queries,
        },
      });
    } catch (e: any) {
      throw new Error(e);
    }
  }

  public async createNewWarehouse(inputData?: any) {
    try {
      return await this.newAxios.post<any>("/warehouse", inputData, {
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": xApiKeyOtodis,
        },
      });
    } catch (e: any) {
      throw new Error(e.response.data.error.message);
    }
  }

  public async getDriver(params?: { dealerCode?: string; active?: boolean }) {
    const queries = {
      ...(params?.dealerCode && {
        dealer_code: params.dealerCode,
      }),
    };
    try {
      return await this.newAxios.get<any>("/dealer/driver", {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
        params: {
          ...queries,
        },
      });
    } catch (e: any) {
      throw new Error(e);
    }
  }

  public async createNewDriver(inputData?: any) {
    try {
      return await this.newAxios.post<any>("/dealer/driver", inputData, {
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": xApiKeyOtodis,
        },
      });
    } catch (e: any) {
      throw new Error(e.response.data.error.message);
    }
  }

  public async getDeliveryVehicle(params?: { dealerCode?: string; active?: boolean }) {
    const queries = {
      ...(params?.dealerCode && {
        dealer_code: params.dealerCode,
      }),
    };
    try {
      return await this.newAxios.get<any>("/dealer/delivery-vehicle", {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
        params: {
          ...queries,
        },
      });
    } catch (e: any) {
      throw new Error(e);
    }
  }

  public async createNewDeliveryVehicle(inputData?: any) {
    try {
      return await this.newAxios.post<any>("/dealer/delivery-vehicle", inputData, {
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": xApiKeyOtodis,
        },
      });
    } catch (e: any) {
      throw new Error(e.response.data.error.message);
    }
  }

  public async getSupplier(params?: any) {
    try {
      return await this.axios.get<any>("/supplier", {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
        params: {
          ...params,
        },
      });
    } catch (e: any) {
      throw new Error(e.response.data.message);
    }
  }

  public async addSupplier(inputData?: any) {
    try {
      return await this.axios.post<any>("/supplier", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
      });
    } catch (e: any) {
      throw new Error(e?.response?.data?.message);
    }
  }
}

export const settingOtodisApiService = new SettingOtodisApiService();
